import { get, post } from './api';
import {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';

export const getTicketsReportLastMonthApi = async (params?: GetTicketsReportLastMonthParamsDTO) => {
  const response = await get<GetTicketsReportLastMonthResponseDTO>(
    `/ticket-reports/last-month`,
    params
  );

  return response.data;
};

export const getClaimReportCardsApi = async (params?: GetClaimReportParamsDTO) => {
  const response = await get<{ reportCards: GetClaimReportsResponseDTO }>(
    `/invoice-reports/report-cards`,
    params
  );

  return response.data.reportCards;
};

export const postTicketsReportScheduleApi = async (params?: GetTicketsReportScheduleParamsDTO) => {
  const response = await post<GetTicketsReportScheduleResponseDTO>(
    `/ticket-reports/schedule`,
    params
  );

  return response.data;
};
